import React, { useState } from "react";
import Popup from "reactjs-popup";
import { PieChart } from "@mui/x-charts/PieChart";
import { useSelector } from "react-redux";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import AlertDrawer from "../../components/shared/alertDrawer";
import { renderCompliantIcon, renderCIAIcon, Accordion } from './CommonComplianceComponents';
// import ComplianceAlertSidebar from "../../components/shared/ComplianceAlertSidebar";


const CompliancePopup = ({ isOpen, onClose, selectedCard, reloadData }) => {
  const data = useSelector(
    (state) => state.ComplianceReducer.complianceStateData?.standardRules
  );
  const [selectedAlertId, setSelectedAlertId] = useState(null);
  const [stateOpen, setStateOpen] = useState(false);
  const openAlertSidePopup = (event, alertId) => {
    // Function to handle opening the alert side popup
    // This function should be defined in the parent component or context
    toggleDrawer(true, event, alertId);
  }
   const toggleDrawer = (open, event, alertId) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setSelectedAlertId(alertId);
    setStateOpen(open);
  };
  if (!selectedCard) return null;
  const selected_id = selectedCard.id;
  return (
    <>
        {selectedAlertId &&
        <AlertDrawer
                  alertDetailsId={selectedAlertId}
                  toggleDrawer={toggleDrawer}
                  stateOpen={stateOpen}
                  project={"DDV"}
                  isCompliance={true}
                />}
      <Popup open={isOpen} onClose={onClose} closeOnDocumentClick={false} modal>
        <div className="popup-container">
          <div className="compliancePopupHeaderContainer">
            <div className="complianceTitleContainer">
              <div className="popup-title">{selectedCard.title}</div>
              <div className="popup-compliance">
                <PieChart
                  series={selectedCard.pieChartData}
                  colors={selectedCard.color}
                  width={180}
                  height={100}
                  sx={{
                    "& .MuiPieArc-root": {
                      stroke: "black",
                      strokeWidth: 1.5,
                    },
                  }}
                  slotProps={{
                    legend: { hidden: true },
                  }}
                />
              </div>
            </div>
            <div className="complianceClose">
              <button className="close-button" onClick={onClose}>
                &times;
              </button>
            </div>
          </div>
          <div className="complianceTableContainer">
            <div className="popUpTable">
              {data && selectedCard.pieChartData && <Paper
                className="cp-container popUp"
                sx={{ width: "100%", overflow: "hidden", marginTop: 1 }}
                elevation={0}
              >
                <div className="float-right">
                  Confidentiality (C) | Integrity (I) | Availability (A)
                </div>
                <TableContainer sx={{ maxHeight: 500 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow className="tbl-header">
                        <TableCell className="cell-width">Control Name</TableCell>
                        <TableCell className="cell-width"></TableCell>
                        <TableCell className="cell-width"></TableCell>
                        <TableCell className="cell-width"></TableCell>
                        <TableCell className="cell-width" align="center">
                          Compliance Status
                        </TableCell>
                        <TableCell className="cell-width" align="center">
                          Remarks
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.map((item) => {
                        const yesObj =
                          selectedCard?.pieChartData?.[0]?.data?.find(
                            (data) => data.type === "Yes"
                          ) || null;

                        if (item.id === selected_id) {
                          return (
                            <TableRow key={item.id}>
                              <TableCell colSpan="6" className="pad-0">
                                <Accordion
                                  isExpanded={true}
                                  onChange={() => { }}
                                  item={item}
                                  yesObj={yesObj}
                                >
                                  <Table className="tbl-data-container">
                                    {item.sections?.map((section) => {
                                      let lastUpdatedDate = '';
                                      if (section.lastUpdatedTimestamp) {
                                        const date = new Date(Number(section.lastUpdatedTimestamp));
                                        const mm = String(date.getMonth() + 1).padStart(2, '0');
                                        const dd = String(date.getDate()).padStart(2, '0');
                                        const yyyy = date.getFullYear();
                                        const hh = String(date.getHours()).padStart(2, '0');
                                        const min = String(date.getMinutes()).padStart(2, '0');
                                        lastUpdatedDate = `${mm}-${dd}-${yyyy} ${hh}:${min}`;
                                      }
                                      return (
                                        <TableRow
                                          key={section.sectionDescription}
                                          className="tbl-data-row"
                                        >
                                          <TableCell className="cell-width" title="last Known State: -">
                                            {section.sectionDescription}
                                          </TableCell>
                                          <TableCell
                                            className="cell-width"
                                            align="center"
                                          >
                                            {renderCIAIcon(section["c"])}
                                          </TableCell>
                                          <TableCell
                                            className="cell-width"
                                            align="center"
                                          >
                                            {renderCIAIcon(section["i"])}
                                          </TableCell>
                                          <TableCell
                                            className="cell-width"
                                            align="center"
                                          >
                                            {renderCIAIcon(section["a"])}
                                          </TableCell>
                                          <TableCell
                                            className="cell-width"
                                            align="center"
                                          >
                                            {renderCompliantIcon(
                                              section.compliant,
                                              section.remark
                                            )}
                                          </TableCell>
                                          <TableCell className="cell-width font-italic pad35">
                                            Last updated Time: {lastUpdatedDate}<br />
                                            Status Changed from {section.lastKnownState ? section.lastKnownState : "Unknown"} to {section.currentState}<br />
                                            <a href="#" onClick={(e) => openAlertSidePopup(e, section.alertId)}>Reason:</a> {section.remark}
                                          </TableCell>
                                        </TableRow>
                                      )
                                    })}
                                  </Table>
                                </Accordion>
                              </TableCell>
                            </TableRow>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>}
            </div>
          </div>
        </div>
      </Popup>
    </>
  );
};

export default CompliancePopup;
